export function findZone(value, zones) {
  const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/œ/g, 'oe').replace(/[^a-z0-9]/g, '')
  const city = normalize(value.replace(/\b\d{5}\b/g, ''))
  if (city === 'strasbourg') return zones[0]
  return zones.slice(1, 5).find(z => z.communes.split(',').some(c => normalize(c) === city))
}

export function localDate() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
}

export function photoError(file) {
  if (!file) return ''
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return 'Choisissez une photo JPG, PNG ou WebP.'
  if (file.size > 5 * 1024 * 1024) return 'Cette photo dépasse 5 Mo. Choisissez une image plus légère.'
  if (!file.size) return 'Ce fichier est vide. Choisissez une autre photo.'
  return ''
}

export function requestText(data) {
  return `Demande SDS — Intervention à programmer\n\nNom : ${data.name}\nTéléphone : ${data.phone || 'Non renseigné'}\nE-mail : ${data.email || 'Non renseigné'}\nBesoin : ${data.problem}\nCommune : ${data.city}\nDéplacement seul : ${data.travel}\nDate souhaitée : ${data.date || 'À convenir'}\nDisponibilités : ${data.availability || 'À convenir'}\nSécurité souhaitée : ${data.security}\n\n${data.description}\n\nPhoto : ${data.photoName || 'Aucune'}\n\nLe créneau, les pièces et le montant total restent à confirmer avec SDS.`
}
